// Port of api/fuel/app/classes/filter/package/games/rating/package/trend.php
import F from 'offline/filter/constants'
import Constants from 'offline/constants'
export default {
	run: function(pkg, local, global) {
		if (global.ownerType === F.OWNER_USER) return pkg
		var revisions = (global.revisions && global.revisions[local.game_id]) ? global.revisions[local.game_id] : []
		pkg.trend = []
		if (!revisions.length) return pkg

		var trendTotal = revisions.length
		var trendRemainder = trendTotal % 4
		var trendSegmentCount = (trendTotal - trendRemainder) / 4
		var trendSegmentCounts = [trendSegmentCount, trendSegmentCount, trendSegmentCount, trendSegmentCount]

		if (trendRemainder) trendSegmentCounts[0]++
		if (trendRemainder >= 2) trendSegmentCounts[1]++
		if (trendRemainder === 3) trendSegmentCounts[2]++

		var trendIndex = 0
		var trendCount = 0

		for (var i = 0; i < trendTotal; i++) {
			if (trendCount === trendSegmentCounts[trendIndex]) {
				trendCount = 0
				trendIndex++
			}

			trendCount++

			if (!pkg.trend[trendIndex]) {
				pkg.trend[trendIndex] = {
					value: {},
					start: 0,
					end: 0,
					count: 0,
					changes: {
						added: 0,
						updated: 0,
						removed: 0
					}
				}

				if (trendIndex > 0) {
					pkg.trend[trendIndex].value = Object.assign({}, pkg.trend[trendIndex - 1].value)
				}
			}

			var rating = revisions[i]
			if (pkg.trend[trendIndex].start === 0) pkg.trend[trendIndex].start = parseInt(rating.log_date || 0, 10)
			if (pkg.trend[trendIndex].end < rating.log_date) pkg.trend[trendIndex].end = parseInt(rating.log_date || 0, 10)

			if (parseInt(rating.log_context || 0, 10) === Constants.LOG_CONTEXT_REMOVED) {
				delete pkg.trend[trendIndex].value[rating.user_id]
				pkg.trend[trendIndex].changes.removed++
			} else {
				pkg.trend[trendIndex].value[rating.user_id] = parseFloat(rating.log_rating || 0)
				if (parseInt(rating.log_context || 0, 10) === Constants.LOG_CONTEXT_ADDED) pkg.trend[trendIndex].changes.added++
				if (parseInt(rating.log_context || 0, 10) === Constants.LOG_CONTEXT_UPDATED) pkg.trend[trendIndex].changes.updated++
			}
		}

		for (var j = 0; j < pkg.trend.length; j++) {
			var values = Object.values(pkg.trend[j].value || {})
			pkg.trend[j].count = values.length
			pkg.trend[j].value = values.length ? Math.round((values.reduce(function(sum, value) { return sum + value }, 0) / values.length) * 10) / 10 : 0
		}
		return pkg
	}
}
